import React from "react";
import {
  Box,
  Chip,
  CircularProgress,
  Stack,
  SxProps,
  Theme,
  Typography,
} from "@mui/material";
import { EmptyState, Link } from "@shopify/polaris";
import { FaAngleRight } from "react-icons/fa";
import { FiChevronRight } from "react-icons/fi";
import { useNavigate, useParams } from "react-router-dom";
import { getListTestAnswers } from "../services";
import emptyIMG from "../../../media/empty.png";

import dayjs from "dayjs";
import { useInfiniteScroll } from "entities/community/components/useInfiniteScroll";

export function formatDuration(durationMs: number) {
  const totalMinutes = Math.floor(durationMs / 1000 / 60);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  if (hours === 0 && minutes === 0) return "0 phút";
  return `${hours > 0 ? `${hours} giờ ` : ""}${minutes} phút`;
}

const style: SxProps<Theme> = {
  display: "flex",
  // flex: 1,
  px: 3,
  gap: 2,
  flexWrap: "wrap",
};
const ListDataTest = [
  {
    id: "listening",
    name: { id: "1", title: "Listening" },
  },
  {
    id: "reading",
    name: { id: "1", title: "Reading" },
  },
  {
    id: "speaking",
    name: { id: "1", title: "Speaking" },
  },
  {
    id: "writing",
    name: { id: "1", title: "Writing" },
  },
];
const GradingTest = () => {
  const params = useParams();
  const navigate = useNavigate();

  const { testId } = params;
  // const [listTest, setListTest] = React.useState([]);
  // const [loading, setLoading] = React.useState<boolean>(true);
  const { items: listTest, loading } = useInfiniteScroll(getListTestAnswers, {
    test_id: testId,
    order_by: "DESC",
  });
  // React.useEffect(() => {
  //   setLoading(true);
  //   getListTestAnswers({ test_id: testId, order_by: "DESC" }).then((res) => {
  //     if (!res?.isError) {
  //       setListTest(res);
  //     } else {
  //       alert("fail to fetch data");
  //     }
  //     setLoading(false);
  //   });
  // }, []);
  const renderItemTest = (item) => {
    return (
      <Stack
        width="100%"
        minWidth={400}
        p={2}
        mt={2}
        spacing={1}
        sx={{
          boxShadow: "2px 4px 10px #ededeb",
          borderRadius: "8px",
          bgcolor: "#ffffff",
          cursor: item.type === "writing" ? "pointer" : "default",
          opacity: ["reading", "speaking", "listening", "writing"].includes(
            item.type
          )
            ? 1
            : 0.6,
          pointerEvents: ["reading", "speaking", "listening"].includes(
            item.type
          )
            ? "none"
            : "auto",
        }}
        onClick={() => {
          const disallowedTypes = ["reading", "speaking", "listening"];
          if (disallowedTypes.includes(item.type)) return;

          navigate(`/grading-test/list/${testId}/${item._id}`, {
            state: {
              answers: item.answers,
              type: item.type,
            },
          });
        }}
      >
        <Typography variant="subtitle1" fontWeight="bold">
          {item?.user_id?.display_name}
        </Typography>

        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="body2" color="text.secondary">
            Hoàn thành:{" "}
            {item.finished_time >= 60000
              ? formatDuration(item.finished_time)
              : "Dưới 1 phút"}
          </Typography>

          <Typography variant="body2" color="text.secondary">
            {dayjs(item?.createdAt).format("DD/MM/YYYY")}
          </Typography>
        </Stack>

        {item.type === "writing" ? (
          <Stack direction="row" spacing={1.5} flexWrap="wrap">
            {(item.writing_score_details || []).length === 0 ? (
              <Typography variant="body2" color="text.secondary">
                Điểm: -
              </Typography>
            ) : (
              item.writing_score_details.map((detail) => (
                <Chip
                  key={detail.index}
                  size="small"
                  color="primary"
                  variant="outlined"
                  label={
                    <>
                      <Typography component="span" variant="caption" color="text.secondary">
                        {`Task ${detail.index + 1}: `}
                      </Typography>
                      <Typography component="span" variant="body2" fontWeight={700} color="primary.main">
                        {detail.score ?? "-"}
                      </Typography>
                    </>
                  }
                />
              ))
            )}
          </Stack>
        ) : (
          <Typography variant="body2" color="primary.main" fontWeight="medium">
            Điểm:{" "}
            {(() => {
              const type = item.type;
              const band = item.band_detail || {};
              if (type === "reading") return band.reading_point ?? "-";
              if (type === "listening") return band.listening_point ?? "-";
              if (type === "speaking") return band.speaking_point ?? "-";
              return "-";
            })()}
          </Typography>
        )}
      </Stack>
    );
  };
  if (loading) {
    return (
      <Box sx={{ display: "flex", flex: 1, justifyContent: "center", mt: 2 }}>
        <CircularProgress size={30} />
      </Box>
    );
  } else if (listTest.length == 0) {
    return <EmptyState heading="Chưa có bài thi nào" image={emptyIMG} />;
  }

  return (
    <Box sx={style}>
      {listTest.map((item, index) => (
        <Link removeUnderline url={item.id} key={index}>
          {renderItemTest(item)}
        </Link>
      ))}
    </Box>
  );
};

export default GradingTest;
